const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbzIeAzdKAezYDKKDinT-5QsI4gWgjBEULWKCT12WeBzXKOoHJ90iZ_g4m5jHHGaCo_N4g/exec";

/**
 * Envoie les données de recensement étudiant vers le Google Apps Script (mode no-cors)
 * @param {Object} formDataObj - Les données du formulaire
 * @returns {Promise<boolean>}
 */
export async function submitRegistration(formDataObj) {
  const formData = new URLSearchParams();
  Object.keys(formDataObj).forEach(key => {
    formData.append(key, formDataObj[key]);
  });

  await fetch(GOOGLE_SCRIPT_URL, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: formData.toString(),
  });

  return true;
}
